import {
  createFileRoute,
  redirect,
  useNavigate,
  useParams,
} from '@tanstack/react-router'
import { useIsMobile, MOBILE_BREAKPOINT } from '@/hooks/use-mobile'
import MobileSettingsNav from '@/components/dashboard/settings-page/MobileSettingsNav'
import { useSelectedTenantStore } from '@/stores/useSelectedTenantStore'
import { getIdTokenUsingQueryClient } from '@/data/queries'
import { userMeOptions } from '@/data/queryOptions'
import { useEffect, useState } from 'react'

export const Route = createFileRoute('/_authenticated/_settings/user/$userId/')(
  {
    component: RouteComponent,
    loader: async ({ context }) => {
      const { queryClient, authState } = context

      const TENANT_ID = useSelectedTenantStore.getState().selectedTenantId
      if (!TENANT_ID) {
        throw redirect({ to: '/select-tenant' })
      }
      const idToken = await getIdTokenUsingQueryClient({
        queryClient,
        authState: authState!,
      })

      // Preload user data for the mobile nav
      await queryClient.ensureQueryData(userMeOptions(TENANT_ID, idToken!))
    },
  },
)

function RouteComponent() {
  const isMobile = useIsMobile()
  const navigate = useNavigate()
  const { userId } = useParams({
    from: '/_authenticated/_settings/user/$userId',
  })
  const [shouldCheckRedirect, setShouldCheckRedirect] = useState(false)

  // Wait for component to mount and window to be available
  useEffect(() => {
    // Set a flag after mount to indicate we can safely check the window width
    setShouldCheckRedirect(true)
  }, [])

  // On desktop, redirect to my-profile
  useEffect(() => {
    if (!shouldCheckRedirect) return

    // TODO: This double-check for mobile state is a workaround to make sure the mobile state is correct.
    const isActuallyMobile = window.innerWidth < MOBILE_BREAKPOINT

    if (!isActuallyMobile) {
      navigate({
        to: '/user/$userId/my-profile',
        params: { userId },
        replace: true,
      })
    }
  }, [shouldCheckRedirect, isMobile, navigate, userId])

  // On mobile, show the navigation menu
  return <MobileSettingsNav />
}
